import React from 'react';
import TextInfo from '@gcloud-npm/next12.components.text-info-n';
import Image from '@gcloud-npm/next12.components.image-n';
import useMediaQuery from '@/hooks/useMediaQuery';

const BannerImgText = (props) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <>
      <section
        className={`BannerImgText container ${
          props['Image-1'].positionMobile === 'bottom'
            ? 'positionImgBottom'
            : ''
        } ${
          props['TextInfo-1'].color === 'white' ? 'backgroundColorBlue' : ''
        }`}
      >
        {props['Image-1'] && props['Image-1'].src && (
          <div className="image">
            <Image
              src={`${process.env.NEXT_PUBLIC_CDN}/${props['Image-1'].src}`}
              alt={props['Image-1'].alt}
              layout="fixed"
              width={props['Image-1'].width}
              height={props['Image-1'].height}
            />
          </div>
        )}
        <div className="textContainer">
          <div className="title">
            <TextInfo
              {...props['TextInfo-1']}
              align={
                isMobile
                  ? props['TextInfo-1'].align
                  : props['TextInfo-1'].alignDesktop
              }
            />
          </div>
          {props['TextInfo-2'] && props['TextInfo-2'].text && (
            <div className="text">
              <TextInfo {...props['TextInfo-2']} />
            </div>
          )}
        </div>
      </section>
      <style jsx>
        {`
          .BannerImgText {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background-color: var(--color-emp--grey1);
            padding: 2rem;
            .image {
              padding-top: 2rem;
            }
            .textContainer {
              .text {
                margin-top: 2rem;
              }
            }
          }
          .positionImgBottom {
            flex-direction: column-reverse;
          }
          .backgroundColorBlue {
            background-color: var(--color-emp--blue);
          }

          @media screen and (min-width: 769px) {
            .BannerImgText {
              flex-direction: row;
              margin-top: 2rem;
              .image {
                margin-left: 5%;
                padding-top: 0;
              }
              .textContainer {
                margin-left: 2rem;
                margin-right: 5%;
              }
            }
          }
        `}
      </style>
    </>
  );
};

export default BannerImgText;
